<template>
  <div class="StudentQuestion edit-style detail">
    <div class="navigation">
      <van-icon name="arrow-left" size="24" @click="goBack" />
      <p class="title">举一反三</p>
      <div class="hidden-box"></div>
    </div>
    <!-- -->
    <van-loading v-if="loading" size="24px">加载中...</van-loading>
    <div class="question-box">
      <p v-if="trainingData.question" class="anaws-box-title">题干</p>
      <div class="question" v-html="trainingData.question"></div>
      <p v-if="trainingData.answer" class="anaws-box-title">答案</p>
      <div v-if="trainingData.answer" v-html="trainingData.answer"></div>
      <p v-if="trainingData.analysis" class="anaws-box-title">答案解析</p>
      <div v-if="trainingData.analysis" v-html="trainingData.analysis"></div>
      <p v-if="trainingData.analyse" class="anaws-box-title">分析</p>
      <div v-if="trainingData.analyse" v-html="trainingData.analyse"></div>
      <p v-if="trainingData.ability" class="anaws-box-title">点评</p>
      <div v-if="trainingData.ability" v-html="trainingData.ability"></div>
    </div>
  </div>
</template>

<script>
import { traininglist } from "@/api/interface";
export default {
  name: "StudentQuestion",
  data() {
    return {
      trainingData: [],
      loading: true,
    };
  },
  created() {
    this.getRraininglist();
  },
  mounted() {
    window.goBackView = this.goBackView;
  },
  methods: {
    goBackView() {
      this.goBack();
      // window.mobile.closeMobileUI();
    },
    goBack() {
      this.$router.go(-1);
    },
    getRraininglist() {
      let data = this.$route.query;
      // console.log(data);

      traininglist(data)
        .then((res) => {
          this.trainingData = res.data[0];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.StudentQuestion {
  .van-loading {
    text-align: center;
    margin-top: 12px;
  }
}

.question-box {
  padding: 12px;

  .anaws-box-title {
    margin-bottom: 12px;
  }
  .question {
    // padding: 12px;
    // border: 1px solid #7b9cc7;
    // border-radius: 4px;
  }
}
</style>
